import hljsToPrismLangMap from 'shared/constants/hljsToPrismLangMap';


// Constrain to this language subset for now.
const defaultSubset = Object.keys(hljsToPrismLangMap);

const hljsDetectLanguage = (text) => {
  // We load hljs async outside of our own bundle, so we should
  // do syntax highlighting on a best effort basis.
  if (!window.hljs) {
    return;
  }

  const { language } = window.hljs.highlightAuto(text, defaultSubset);
  return language;
};


export default hljsDetectLanguage;



// WEBPACK FOOTER //
// ./src/shared/helpers/hljsDetectLanguage.js